
import React from 'react';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { TIME_SLOTS } from '@/types/teacherAvailability';

interface TimeSlotFormData {
  startTime: string;
  endTime: string;
}

interface TimeSlotFormProps {
  tempSchedule: TimeSlotFormData;
  setTempSchedule: React.Dispatch<React.SetStateAction<TimeSlotFormData>>;
  onSave: () => void;
  onCancel: () => void;
  isEditing: boolean;
}

export function TimeSlotForm({ 
  tempSchedule, 
  setTempSchedule, 
  onSave, 
  onCancel, 
  isEditing 
}: TimeSlotFormProps) {
  return (
    <div className="bg-blue-50 p-3 md:p-4 rounded-lg border-2 border-blue-200">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 mb-3">
        <Select
          value={tempSchedule.startTime}
          onValueChange={(value) => 
            setTempSchedule(prev => ({ ...prev, startTime: value }))
          }
        >
          <SelectTrigger className="w-full sm:w-24 h-8 text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {TIME_SLOTS.map(time => (
              <SelectItem key={time} value={time}>{time}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        <span className="text-center sm:text-left">-</span>
        
        <Select
          value={tempSchedule.endTime}
          onValueChange={(value) => 
            setTempSchedule(prev => ({ ...prev, endTime: value }))
          }
        >
          <SelectTrigger className="w-full sm:w-24 h-8 text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {TIME_SLOTS.map(time => (
              <SelectItem key={time} value={time}>{time}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex gap-2">
        <Button size="sm" onClick={onSave} className="flex-1 h-8 text-sm">
          {isEditing ? 'อัพเดท' : 'เพิ่ม'}
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel} className="flex-1 h-8 text-sm">
          ยกเลิก
        </Button>
      </div>
    </div>
  );
}
